var _Path, _Path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

function SvgWorkoutSettings(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 23,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#workout-settings_svg__clip0_359:92)",
    stroke: props.color,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M11.422 26.583c5.49 0 9.942-4.734 9.942-10.573 0-5.84-4.452-10.573-9.942-10.573-5.491 0-9.943 4.734-9.943 10.573 0 5.84 4.452 10.573 9.943 10.573zM8.282.98h6.286M18.457 8.534l1.868-1.986"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M9.855 5.483V.98h3.14v4.503M19.797 5.992l1.05 1.111M11.422 16.01l-4.707-5.012"
  }))), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "workout-settings_svg__clip0_359:92"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: props.color,
    transform: "translate(.558)",
    d: "M0 0h21.734v27.563H0z"
  }))));
}

export default SvgWorkoutSettings;